import { useState } from "react";
import SidePanel from "../components/SidePanel";
import EdgeAnalysisSemanticFilters from "../components/EdgeAnalysisSemanticFilters";
import HeatmapPlotFilters from "../components/HeatmapPlotFilters";

const EdgeAnalysisPage = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [activeChart, setActiveChart] = useState("semantic");
  const [displayData, setDisplayData] = useState();

  return (
    <div className="flex relative">
      <SidePanel
        collapseCallback={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
        data={displayData}
      />
      <div className="grow">
        <div className="p-6">
          <h1 className="mb-6 text-center">Edge Analysis</h1>
          <div className="w-full flex flex-col items-center content-center overflow-y-auto custom-scrollbar h-[83vh]">
            <div className="flex flex-col items-center content-center gap-6">
              <div className="flex gap-4 items-center content-center">
                {/* <button
                  onClick={() => setActiveChart("composite")}
                  className={`${
                    activeChart === "composite" ? "bg-blue-800" : "bg-blue-500"
                  }  text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-200`}
                >
                  Causal
                </button> */}
                <button
                  onClick={() => setActiveChart("semantic")}
                  className={`${
                    activeChart === "semantic" ? "bg-blue-800" : "bg-blue-500"
                  } disabled:opacity-[0.4] text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-200`}
                >
                  Semantic
                </button>
              </div>
              <div>
                {activeChart === "semantic" && (
                  <EdgeAnalysisSemanticFilters
                    propagnateData={(value) => setDisplayData(value)}
                  />
                )}
                {activeChart === "composite" && (
                  <HeatmapPlotFilters
                    propagnateData={(value) => setDisplayData(value)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdgeAnalysisPage;
